import React from 'react'

import { IconMute } from 'component-library/icons/IconMute/IconMute'
import {
    StyledUnmuteButton,
    Props,
} from 'component-library/content/Video/components/UnmuteButton/UnmuteButton.styled'
import { classNames } from 'common/emotion'

export const UnmuteButton: React.FC<Props> = props => {
    const isCrushed = props.positionState && props.positionState.alignToTop
    const isLowered = props.positionState && props.positionState.isLowered && !isCrushed

    return (
        <StyledUnmuteButton
            className={classNames({ isCrushed, isLowered })}
            onClick={props.action}
            type="button"
        >
            <IconMute /> Click to unmute
        </StyledUnmuteButton>
    )
}
